<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <form @submit.prevent="submit">
          <v-card
            class="mx-auto"
            max-width="650"
          >
            <v-card-title class="bg-primary d-flex align-center">
              <div class="banner-side d-flex align-center">
                <v-btn
                  color="white"
                  icon
                  to="/home"
                >
                  <v-icon size="large">
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </div>
              <span
                class="text-h5 white-text text-center"
                style="word-break: break-word"
              >
                Register for Database Portal
              </span>
              <div class="banner-side" />
            </v-card-title>
            <v-divider />
            <v-card-text v-show="!registered">
              <v-text-field
                v-model="user.firstName"
                label="First Name"
              />
              <v-text-field
                v-model="user.lastName"
                label="Last Name"
              />
              <v-text-field
                v-model="user.email"
                label="Email"
                :rules="emailValidation"
              />
              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                :rules="passwordValidation"
              />
              <v-text-field
                v-model="confirmPassword"
                label="Confirm Password"
                type="password"
                :rules="confirmValidation"
              />
            </v-card-text>
            <v-card-text
              v-if="message && registered"
              style="font-size: medium"
            >
              {{ message }}
            </v-card-text>
            <v-card-text
              v-if="message && !registered"
              style="font-size: medium; color: red"
            >
              {{ message }}
            </v-card-text>
            <v-card-actions>
              <v-row
                class="ma-2"
                justify="end"
              >
                <v-btn
                  v-if="!registered"
                  class="ml-2"
                  color="primary"
                  type="submit"
                >
                  <span>Register</span>
                </v-btn>
                <v-btn
                  v-if="registered"
                  class="ml-2"
                  color="primary"
                  type="placeholder"
                  :to="homePath"
                >
                  <span>Login</span>
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import HumpbackLogo from "@/components/svgs/HumpbackLogo";

export default {
  components: {
    // HumpbackLogo,
  },

  data() {
    return {
      password: "",
      confirmPassword: "",
      selectedRoleId: "3", // User Role
      emailValidation: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      passwordValidation: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 6) || "Password must be greater than 6 characters",
      ],
      confirmValidation: [
        (v) => !!v || "Confirm password is required",
        (v) =>
          v === this.password || "The password confirmation does not match.",
      ],
      registered: false,
      saveFailed: false,
      registerAccountPath: "/register",
      homePath: "/",
    };
  },
  computed: {
    ...mapGetters({
      user: "user/details/user",
      message: "user/details/message",
    }),
  },
  watch: {
    user(user) {
      this.selectedRoleId = user ? user.roleId : null;
      this.setMessage("");
      this.password = user ? user.password : null;
    },
  },
  created() {
    this.reset();
    if (this.isTokenSet) {
      if (this.role === "admin") {
        this.$router.push({ name: "sightings" });
      }
      this.$router.push({ name: "sightings" });
    }
  },
  methods: {
    ...mapActions({
      reset: "auth/reset",
      register: "user/details/register",
      close: "user/details/close",
      setMessage: "user/details/setMessage",
    }),
    checkCanSave() {
      return (
        this.password === this.confirmPassword && this.password.length >= 6
      );
    },
    async submit() {
      if (this.checkCanSave()) {
        try {
          await this.save();
          await this.register(this.user);
          await this.setMessage(
            "You have successfully registered an account, proceed to login."
          );
          this.confirmPassword = "";
          this.registered = true;
        } catch (e) {
          this.registered = false;
          if (this.saveFailed) {
            await this.setMessage(e);
          } else {
            await this.close();
            await this.setMessage(
              "Something went wrong. If you already have an account associated with this email, try logging in or contact info@bcwhales.org for help."
            );
            this.confirmPassword = "";
          }
        }
      }
    },
    async save() {
      this.saveFailed = true;
      this.user.password = this.password;
      if (!this.user.firstName) {
        throw Error("The user must have a first name!");
      }
      if (!this.user.lastName) {
        throw Error("The user must have a last name!");
      }
      if (!this.user.password) {
        throw Error("The user must have a password!");
      }
      if (!this.confirmPassword) {
        throw Error("Must confirm the password!");
      }
      if (!this.user.email) {
        throw Error("The user must have a email!");
      }
      this.user.roleId = this.selectedRoleId;
      this.saveFailed = false;
    },
  },
};
</script>

<style scoped>
.banner-side {
  flex: 1 1 0;
}
</style>
